// extracted by mini-css-extract-plugin
export var dataCell = "_lv-2";
export var dataRow = "_lv-0";
export var headerRow = "_lv-1";